module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-04-e807c5a8abe937e5ec74aaa82fd33b0b.jpg";